import Link from "next/link";
import Heading from "../../components/Heading";
import React, { useState } from 'react'
import { useRouter } from "next/router";

const SettingsLayout = function ({ title = "", isLoading = false, children }) {
    const router = useRouter();
    const path = router.pathname
    console.log(path)
    return (
        <>
            <Heading title={title} showLoader={isLoading} />    

            <div className="container">
                <div className="row gutters-sm">
                    <div className="col-md-3 d-none d-md-block border-end">
                        <div className="card border-0">

                            <div className="list-group list-group-flush">

                                <Link href="/settings" className={`list-group-item list-group-item-action ${(path == '/settings') && 'active'}`}>
                                    Pincode
                                </Link>
                                <Link href="/settings/banner" className={`list-group-item list-group-item-action ${(path == '/settings/banner') && 'active'}`}>
                                    Banner
                                </Link>
                                

                            </div>
                        </div>
                    </div>
                    <div className="col-md-9">
                        <div className="card">
                            <div className="card-header border-bottom mb-3 d-flex d-md-none">
                                <ul className="nav nav-tabs card-header-tabs nav-gap-x-1" role="tablist">
                                    <li className="nav-item">
                                        <a href="/settings" data-toggle="tab" className="nav-link has-icon active"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-user"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg></a>
                                    </li>
                                    
                                </ul>
                                
                            </div>
                            <div className="tab-content">
                                {children}
                            </div>
                        </div>

                    </div>
                    
                </div>
            </div>
        </>
    );

}

export default SettingsLayout;